'use client';

import { useEffect, useRef, useState } from "react";

export function SplineViewer({ url, delay = 4000 }: { url: string; delay?: number }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            if (!document.querySelector('script[src*="spline-viewer.js"]')) {
              const script = document.createElement('script');
              script.type = 'module';
              script.src = 'https://unpkg.com/@splinetool/viewer@1.10.99/build/spline-viewer.js';
              document.head.appendChild(script);
              script.onload = () => setIsLoaded(true);
            } else {
              setIsLoaded(true);
            }
          }, delay);
          observer.disconnect();
        }
      });
    }, { threshold: 0.1 });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return (
    <div ref={containerRef} className="w-full h-full relative">
      {isLoaded && (
        <spline-viewer
          url={url}
          style={{ width: '100%', height: '100%', display: 'block' }}
        />
      )}
    </div>
  );
}

// Add type for custom element
declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'spline-viewer': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & {
          url?: string;
        },
        HTMLElement
      >;
    }
  }
}
